export const gabrielaJaniszewska = {
    'firstName': 'Gabriela',
    'lastName': 'Janiszewska',
    'profession': 'Psycholog, Psychoterapeuta behawioralno-poznawczy',
    'avatar': 'gabriela-janiszewska.webp',
    'slug': 'gabriela-janiszewska',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'pair']
    ]
}